import Numeral from 'numeral';

export class CurrencyFormatter {
    static formFormat(value, decimalPlaces = 4) {
        if (!value && value !== 0) {
            return null;
        }
        const newValue = value / 10000;

        let f = '0.00[00]';

        if (decimalPlaces === 2) {
            f = '0.00';
        }

        return Numeral(newValue).format(f);
    }

    static format(value, divide = true, decimalPlaces = 4) {
        if (!value && value !== 0) {
            return null;
        }

        let newValue = value;
        if (divide) {
            newValue /= 10000;
        }

        let f = '0,0.00[00]';

        if (decimalPlaces === 2) {
            f = '0,0.00';
        }

        return Numeral(newValue).format(f);
    }

    static formatWithSymbol(value, decimalPlaces = 2) {
        const newValue = value / 10000;
        let f = '$0,0.00[00]';

        if (decimalPlaces === 2) {
            f = '$0,0.00';
        }
        return Numeral(newValue).format(f);
    }

    static addCurrencySymbol(value, decimalPlaces) {
        let f = '$0,0.00[00]';

        if (decimalPlaces === 2) {
            f = '$0,0.00';
        }
        return Numeral(value).format(f);
    }

    static convertToInteger(value) {
        return value * 10000;
    }
}

const { format } = CurrencyFormatter;
const currencyFormat = CurrencyFormatter.formatWithSymbol;
const { addCurrencySymbol } = CurrencyFormatter;
const { convertToInteger, formFormat } = CurrencyFormatter;

export default {
    filters: {
        currencyFormat,
        addCurrencySymbol,
        format,
    },
    methods: {
        convertToInteger,
        addCurrencySymbol,
        currencyFormat,
        format,
        formFormat,
    },
};
